<div class="item-group">
  <ng-content></ng-content>
</div>
